module.exports = __webpack_public_path__ + "static/media/18-1.1f25215c.mp3";